<template>
	<component
    :is="tag"
    class="btn"
    :href="url || href"
    :type="!url && type"
    :target="url || href ? target : null"
    :disabled="disabled"
    :class="[
			`btn--${level}`,
      ...variants.map(variant => `btn--${variant}`),
      { 'btn--icon': icon },
      { 'btn--arrow': arrow },
      { 'btn--no-text': !text },
      { 'btn--reverse': reverse },
			{ 'btn--block': block },
      { 'btn--small': small },
      { 'btn--tiny': tiny },
    ]"
    @click="onClick"
  >
		<component
      class="btn__icon"
			v-if="icon"
			:is="iconComponent(icon)"
		/>
    <span
      class="btn__text"
      v-if="text"
      v-sanitize.strip="text"
    />
		<component
      class="btn__arrow"
			v-if="arrow"
			:is="arrowComponent"
		/>
  </component>
</template>

<script>
import {toPascal} from '@/utils/convertcase';

export default {
	props: {
		disabled: Boolean,
		href: String,
		target: String,
		url: String,
		type: String,
		icon: String,
		text: String,
		arrow: Boolean,
		reverse: Boolean,
		block: Boolean,
		small: Boolean,
		tiny: Boolean,
		level: {
			type: String,
			default: 'primary',
		},
		variants: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {
			tag: this.url || this.href ? 'a' : 'button'
		};
	},
	computed: {
		arrowComponent() {
			const icon = this.reverse ? 'mid-circle-chevron-left' : 'mid-circle-chevron-right';
			return `SVG${toPascal(icon)}`;
		},
	},
	methods: {
		onClick(e) {
			this.$emit('click', e);
		}
	}
}
</script>

<style>

</style>